import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/computer-games`;

// Saves a finished game against the computer to your profile (only works when logged in)
export const saveComputerGame = async (game) => {
    return (await axios.post(BASE, game, {withCredentials: true})).data;
};

export const fetchComputerGames = async (username, limit = 10, offset = 0) => {
    return (await axios.get(`${BASE}/list/${encodeURIComponent(username)}?limit=${limit}&offset=${offset}`)).data;
};

export const fetchComputerStatistics = async (username) => {
    return (await axios.get(`${BASE}/stats/${encodeURIComponent(username)}`)).data;
};
